export class LeaveEndDate {
  endDate;
  skippedSat;
  skippedSun;
  skippedHoliday;
  constructor() {
    this.endDate = "";
    this.skippedSat = [];
    this.skippedSun = [];
    this.skippedHoliday = [];
  }
}



// WEBPACK FOOTER //
// ./src/model/LeaveEndDate.js